<template>
  <div class="navbar">
    <div class="title-menu">
      <!-- 如果有LOGO图片，可自行切换 v-if -->
      <el-image
        v-if="false" 
        class="title-img"
        src="https://dummyimage.com/44x44/ccc/fff.png"
        fit="cover"
      ></el-image>
      <div class="title-name">{{ $project.projectName }}</div>
    </div>
    <div class="right-menu">
      <!-- 通知中心组件 -->
      <div class="notification-wrapper">
        <notification-center class="notification-center"></notification-center>
      </div>
      <div class="lang-switcher">
        <el-select v-model="lang" size="mini" @change="onLangChange" style="width: 120px; margin-right: 12px;">
          <el-option label="中文" value="zh-CN"></el-option>
          <el-option label="English" value="en-US"></el-option>
          <el-option label="ไทย" value="th-TH"></el-option>
        </el-select>
      </div>
      
      <div class="user-info">
        <!-- {{ $storage.get('role') }}  -->
       {{ $storage.get('adminName') }}
      </div>
      <div
        v-if="$storage.get('role') !== '管理员'"
        class="logout"
        @click="onIndexTap"
      >
        {{$t('header.toFront')}}
      </div>
      <div class="logout" @click="onLogout">{{$t('header.logout')}}</div>
    </div>
  </div>
</template>

<script>
  import ElementLocale from 'element-ui/lib/locale'
  import enLocale from 'element-ui/lib/locale/lang/en'
  import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
  import thLocale from '@/i18n/element/th-TH'
	export default {
		data() {
			return {
				dialogVisible: false,
				ruleForm: {},
				user: {},
				lang: 'zh-CN',
				// heads: {"headLogoutFontHoverColor":"rgba(255, 255, 255, 1)","headFontSize":"20px","headUserInfoFontColor":"#333","headBoxShadow":"0 1px 0px rgba(255,255,255, 1)","headTitleImgHeight":"44px","headLogoutFontHoverBgColor":"rgba(214, 238, 247, 1)","headFontColor":"#000","headTitleImg":false,"headHeight":"62px","headTitleImgBorderRadius":"22px","headTitleImgUrl":"http://codegen.caihongy.cn/20210130/802eda1d769743a8a04daedec965b026.jpg","headBgColor":"linear-gradient(rgba(255,255,255, 1), rgba(214,238,247, 1),rgba(56,182,230, 1))","headTitleImgBoxShadow":"0 1px 6px #444","headLogoutFontColor":"#333","headUserInfoFontSize":"18px","headTitleImgWidth":"44px","headTitleStyle":"1","headLogoutFontSize":"18px"},
			};
		},
		created() {
			// this.setHeaderStyle()
			// 若需在mounted之前做一些初始化，可写在此处
			this.lang = (this.$i18n && this.$i18n.locale) || window.localStorage.getItem('lang') || 'zh-CN'
			this.applyElementLocale(this.lang)
		},
		mounted() {
			let sessionTable = this.$storage.get("sessionTable")
			this.$http({
				url: sessionTable + '/session',
				method: "get"
			}).then(({
				data
			}) => {
				if (data && data.code === 0) {
					this.user = data.data;
					this.$storage.set('userid',data.data.id);
				} else {
					let message = this.$message
					message.error(data.msg);
				}
			});
		},
		methods: {
			applyElementLocale(lang){
				if(lang === 'en-US') {
					ElementLocale.use(enLocale)
				} else if(lang === 'zh-CN') {
					ElementLocale.use(zhLocale)
				} else if(lang === 'th-TH') {
					ElementLocale.use(thLocale)
				}
			},
			onLangChange(val){
				this.$i18n.locale = val
				window.localStorage.setItem('lang', val)
				this.applyElementLocale(val)
			},
			onLogout() {
				let storage = this.$storage
				let router = this.$router
				storage.clear()
				router.replace({
					name: "login"
				});
			},
      			onIndexTap(){
      				window.location.href = `${this.$base.indexUrl}`
    			},
			setHeaderStyle() {
			  this.$nextTick(()=>{
			    document.querySelectorAll('.navbar .right-menu .logout').forEach(el=>{
			      el.addEventListener("mouseenter", e => {
			        e.stopPropagation()
			        el.style.backgroundColor = this.heads.headLogoutFontHoverBgColor
					el.style.color = this.heads.headLogoutFontHoverColor
			      })
			      el.addEventListener("mouseleave", e => {
			        e.stopPropagation()
			        el.style.backgroundColor = "transparent"
					el.style.color = this.heads.headLogoutFontColor
			      })
			    })
			  })
			},
		},
	};
</script>


<style lang="scss" scoped>
	.navbar {
  height: 62px;
  line-height: 62px;
  width: 100%;
  padding: 0 24px;
  box-sizing: border-box;
  background-color: #fff;
  /* 下方可选择边框或阴影：二选一 */
  /* border-bottom: 1px solid #ebeef5; */
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);

  display: flex;
  align-items: center;
  justify-content: space-between;
	z-index: 1;
    font-family: sans-serif;
	 background-color: #f5f5f5;


  .title-menu {
    display: flex;
    align-items: center;

    .title-img {
      width: 44px;
      height: 44px;
      border-radius: 22px;
      margin-right: 16px;
    }

    .title-name {
      font-size: 18px;
      color: #333;
      font-weight: 600;
    }
  }

  .right-menu {
    display: flex;
    align-items: center;

    .notification-wrapper {
      margin-right: 20px;
      
      .notification-center {
        display: inline-block;
      }
    }

    .user-info {
      font-size: 14px;
      color: #666;
      margin-right: 20px;
    }

    .logout {
      font-size: 14px;
      color: #666;
      cursor: pointer;
      margin-right: 10px;
      &:hover {
        color: #03A9F4;
      }
    }
  }
}
</style>

<style scoped>
@media (max-width: 768px) {
  .index-header {
    padding: 10px;
  }

  .header-content {
    flex-direction: column;
    align-items: center;
  }

  .header-right {
    margin-top: 10px;
  }
}
</style>
